import React from 'react';
import { DEFAULT_SUPPORT_LOGIN_DATA, SuportLoginDataContext, SupportLoginData } from './context';

const SupportLoginDataProvider: React.FC<React.PropsWithChildren<Record<never, any>>> = ({ children }) => {
  const [supportLoginData, setSupportLoginData] =
    React.useState<SupportLoginData>(DEFAULT_SUPPORT_LOGIN_DATA);

  return (
    <SuportLoginDataContext.Provider value={{ supportLoginData, setSupportLoginData }}>
      {children}
    </SuportLoginDataContext.Provider>
  );
};

export default SupportLoginDataProvider;
